import { observer } from 'mobx-react';
import React from 'react';
import b_ from 'b_';

import { i18n } from 'controls/designer/features/widgets/datasources/tile/localization';
import { Section } from 'controls/react/layout/section';
import { BoxView } from 'controls/react/layout/boxView';
import { Grid } from 'controls/grid/grid';
import { DatasourceCategorySelectorProps } from './types';

import { useStore } from 'core/react/useStore';
import { DataSourceCategorySelectorStore } from './dataSourceCategorySelectorStore';

const b = b_.with('datasource-category-selector');

export const DataSourceCategorySelector = observer((props: DatasourceCategorySelectorProps) => {
	const store = useStore(() => new DataSourceCategorySelectorStore(), { props });
	if (!store.gridStore?.selfInitialized) {
		return null;
	}
	return (
		<Section appearance="none" height={'fit'} containerClass={b()}>
			<BoxView type={'info-2'}>
				{i18n(
					'Select the datasource row to use as your data source. This row should contain unique values so it can act as an identifier',
				)}
			</BoxView>
			{!!store.rowsWarningMessage && (
				<BoxView type={'warning'} onClick={store.closeRowsWarning}>
					{store.rowsWarningMessage}
				</BoxView>
			)}
			{!!store.columnsWarningMessage && (
				<BoxView type={'warning'} onClick={store.closeColumnsWarning}>
					{store.columnsWarningMessage}
				</BoxView>
			)}
			<Grid store={store.gridStore} />
		</Section>
	);
});
